<template>
  <div class="sm_star">
    <!-- 상단 고정 캠페인 배너 -->
    <TopAppBarDrawer
      :isDrawerOpen="isDrawerOpen"
      @closeDrawer="closeDrawer"
    ></TopAppBarDrawer>
    <div class="sm_header">
      <button class="menu_btn" @click="openDrawer()">
        <span>mobile menu</span>
      </button>
      <h1 v-if="this.$route.query.status == 'LEARNING'">{{ $t("S10027") }}</h1>
      <h1 v-else>{{ $t("S10026") }}</h1>
      <button class="search_btn" @click="searchOpen">
        <span>search</span>
      </button>
      <div class="search_box">
        <input
          type="text"
          :placeholder="$t('1452')"
          ref="search_form"
          class="search_form"
          @keyup="(e) => inputSearch(e)"
          v-model="contents"
        />
        <button
          type="button"
          class="search_close"
          @click="searchClose()"
        ></button>
        <button type="button" class="search_btn" @click="search()">검색</button>
      </div>
    </div>

    <div class="top-app-bar__learn">
      <TopAppBar
        :leftBtnMode="leftBtnMode"
        :title="title"
        :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod"
        staticMode="true"
      >
      </TopAppBar>
    </div>

    <div
      v-if="
        campaignData &&
        campaignData.dynamicLink &&
        campaignData.locationValue === null
      "
    >
      <a :href="campaignData.dynamicLink.shortLink" target="_blank">
        <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
      </a>
    </div>

    <!-- total count & 진도율 토글 버튼 -->
    <div class="sorting-video primary-sorting">
      <div
        class="d-flex justify-content-between align-items-center pdr-8 pdl-16 pdt-8 pdb-8"
      >
        <div class="t-body3">{{ $t("S20128", { str: totalElements }) }}</div>
        <div class="d-flex justify-content-center align-items-center">
          <div class="mgr-8 t-body3">{{ $t("S20129") }}</div>

          <div
            class="d-flex cursor-pointer mdc-switch mdc-switch--checked mdc-ripple-upgraded mdc-ripple-upgraded--unbounded switch-color"
            @click="onToggle"
          >
            <div class="d-flex mdc-switch mdc-switch--checked">
              <span
                class="material-icons toggle-size"
                :class="{ 'active-checked': progressRateOrder }"
                >{{ progressRateOrder ? "toggle_on" : "toggle_off" }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="divider-line pdb-3" />
    </div>

    <!-- Sorting buttons -->
    <div class="sorting-video pdt-3 d-flex">
      <div
        class="d-flex justify-content-between align-items-center"
        style="width: 100%"
      >
        <div class="d-flex flex-row justify-content-between align-items-center">
          <span class="">
            <button
              class="mdc-icon-button material-icons mdc-card__action mdc-card__action--icon--unbounded degree-card-more-button t-color-bodyGrayA"
              :class="
                listType === 'card' ? 't-color-message-acive' : 't-color-gray0'
              "
              @click="changeMode('card')"
            >
              view_stream
            </button>
          </span>
          <span class="">
            <button
              class="mdc-icon-button material-icons mdc-card__action mdc-card__action--icon--unbounded degree-card-more-button t-color-bodyGrayA"
              :class="
                listType === 'list' ? 't-color-message-acive' : 't-color-gray0'
              "
              @click="changeMode('list')"
            >
              view_list
            </button>
          </span>
        </div>

        <div
          class="cursor-pointer pdl-16 position-relative mdc-menu-anchor menu-container header-toggle d-flex justify-content-end"
        >
          <button
            class="mdc-button t-color-bodyGrayA mdc-button-dk js--dropdown-toggle t-nowrap"
            @click="toggleMenu"
          >
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body3 font-rr t-color-title">
              {{ getSortLabel(sort_selected) }}
            </span>
            <i class="material-icons mdc-button__icon" aria-hidden="true"
              >arrow_drop_down</i
            >
          </button>
          <div class="mdc-menu mdc-menu-surface toggle-menu more_box mgl-16">
            <ul
              class="mdc-list"
              role="menu"
              aria-hidden="true"
              aria-orientation="vertical"
              tabindex="-1"
            >
              <li
                v-for="(item, index) in sortOptions"
                :key="index"
                class="mdc-list-item"
                role="menuitem"
                @click="onSelect(item.value, learnSortConstants.order)"
              >
                <span class="mdc-list-item__ripple"></span>
                <span
                  class="mdc-list-item__text t-body6 font-r font-color-black"
                >
                  {{ $t(item.label) }}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <!-- DESCENDING button -->
        <!-- <div
          class="cursor-pointer position-relative mdc-menu-anchor menu-container header-toggle d-flex justify-content-end"
        >
          <button
            class=" mdc-button t-color-bodyGrayA mdc-button-dk js--dropdown-toggle1 t-nowrap"
            @click="toggleMenu"
          >
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body3 font-rr" style="font-size: 12px">{{
              sort_type == "desc" ? $t("S10047") : $t("S10048")
            }}</span>
            <i class="material-icons mdc-button__icon" aria-hidden="true"
              >arrow_drop_down</i
            >
          </button>
          <div class="mdc-menu1 mdc-menu-surface toggle-menu more_box box-right">
            <ul
              class="mdc-list"
              role="menu"
              aria-hidden="true"
              aria-orientation="vertical"
              tabindex="-1"
            >
              <li
                class="mdc-list-item"
                role="menuitem"
                @click="onSelect('desc', 'sort')"
              >
                <span class="mdc-list-item__ripple"></span>
                <span class="mdc-list-item__text t-body6 font-r font-color-black">{{
                  $t("S10047")
                }}</span>
              </li>
              <li
                class="mdc-list-item"
                role="menuitem"
                @click="onSelect('asc', 'sort')"
              >
                <span class="mdc-list-item__ripple"></span>
                <span class="mdc-list-item__text t-body6 font-r font-color-black">{{
                  $t("S10048")
                }}</span>
              </li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>

    <div class="divider-line pdb-3" />

    <NoData
      v-if="isNoData"
      :title="$t('S20075')"
      :subTitle="$t('S20076')"
    ></NoData>
    <div class="pdl-16 pdr-16 pdb-20">
      <component
        :is="listType"
        :listData="listData"
        :campaignData="campaignData"
        :initProgressStatus="initProgressStatus"
        :status="status"
      />

      <infinite-loading
        @infinite="fetchData"
        :identifier="infiniteId"
        spinner="spiral"
      >
        <div slot="no-more" class="mgt-16">No more data</div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCMenu } from "@material/menu";
import { MDCMenuSurface } from "@material/menu-surface";
import { MDCSwitch } from "@material/switch";
import { mapState } from "vuex";
import InfiniteLoading from "vue-infinite-loading";

import learnApi from "@/api/learnApi.js";
import campaignApi from "@/api/campaignApi.js";

import { topAppBarMixin } from "@/mixins/topAppBar.js";

import ListItem from "./ListItem.vue";
import NoData from "../common/NoData2.vue";
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

import { learnSortConstants } from "@/utils/constants/filterConstants.js";

export default {
  components: {
    ListItem,
    NoData,
    InfiniteLoading,
    TopAppBarDrawer,
    TopAppBar,
    card: () => import("./TotalCard.vue"),
    list: () => import("./TotalList.vue"),
  },

  data() {
    return {
      title: "",
      status: "",
      contents: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      listData1: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      searchName: "",
      isDrawerOpen: false,
      sort_selected: localStorage.getItem(learnSortConstants.sortSelected)
        ? localStorage.getItem(learnSortConstants.sortSelected)
        : learnSortConstants.registrationDate,
      sort_type: learnSortConstants.desc,
      menuBar: null,
      menuBar1: null,
      listType: "card",
      totalElements: 0,
      progressRateOrder: JSON.parse(
        localStorage.getItem(learnSortConstants.isProgressRateOrder)
      )
        ? JSON.parse(
            localStorage.getItem(learnSortConstants.isProgressRateOrder)
          )
        : false,
      sortOptions: [
        { value: learnSortConstants.registrationDate, label: "S10044" },
        { value: learnSortConstants.likes, label: "S20135" },
        { value: learnSortConstants.courseTitle, label: "S10045" },
      ],
    };
  },

  mixins: [topAppBarMixin],

  computed: {
    ...mapState({
      progress: (state) => state.learn.progress,
    }),
    learnSortConstants() {
      return learnSortConstants;
    },
  },

  watch: {
    $route(to, from) {
      if (to.path === from.path) {
        this.initData();
      }

      if (this.$route.query.status == "LEARNING") {
        this.setTopAppBarBackSearch(this.$t("S10027"));
      } else {
        this.setTopAppBarBackSearch(this.$t("S10026"));
      }
    },

    progress(newProgress, oldProgress) {
      this.listData = this.listData1;
      this.listData = this.listData.map((arr) => {
        if (newProgress.id == arr.id) {
          arr.progressRate = newProgress.progress;
        }
        return arr;
      });
    },
  },

  updated() {
    // 네비게이션 메뉴 설정(set navigation menu)
    this.addedMenu = MDCMenuSurface.attachTo(
      document.getElementById("addedMenu")
    );
    this.addedMenu.setAnchorMargin({
      bottom: 10,
      left: 10,
      right: 16,
      top: 40,
    });
  },

  mounted() {
    this.initData();
    this.metarialUIData();

    if (this.$route.query.status == "LEARNING") {
      this.setTopAppBarBackSearch(this.$t("S10027"));
    } else {
      this.setTopAppBarBackSearch(this.$t("S10026"));
    }
  },

  methods: {
    metarialUIData() {
      const menuEls = Array.from(document.querySelectorAll(".mdc-menu"));
      // myMenu = document.querySelector(.'mdc-button-dk')
      menuEls.forEach((menuEl) => {
        this.menuBar = new MDCMenu(menuEl);
        const dropdownToggle = menuEl.parentElement.querySelector(
          ".js--dropdown-toggle"
        );
        dropdownToggle.addEventListener("click", () => {
          this.menuBar.open = !this.menuBar.open;
        });
      });
      // const menuEls1 = Array.from(document.querySelectorAll(".mdc-menu1"));
      // // myMenu = document.querySelector(.'mdc-button-dk')
      // menuEls1.forEach((menuEl1) => {
      //   this.menuBar1 = new MDCMenu(menuEl1);
      //   const dropdownToggle = menuEl1.parentElement.querySelector(
      //     ".js--dropdown-toggle1"
      //   );
      //   dropdownToggle.addEventListener("click", () => {
      //     this.menuBar1.open = !this.menuBar1.open;
      //   });
      // });
      for (const el of document.querySelectorAll(".mdc-switch")) {
        const switchControl = new MDCSwitch(el);
      }
    },
    onSelect(key, type) {
      // this.menuBar.open = !this.menuBar.open;
      this.menuBar.open = false;
      // this.menuBar1.open = false;
      if (type === "order") {
        this.sort_selected = key;
        localStorage.setItem(learnSortConstants.sortSelected, key);
      }
      if (type === "sort") {
        this.sort_type = key;
      }

      this.search();
    },

    toggleMenu(evt) {
      let field = evt.target
        .closest(".header-toggle")
        .querySelector(".more_box");
      field.classList.toggle("mdc-menu-surface--open");
      field.classList.toggle("mdc-menu-surface--is-open-below");
    },
    toggleAddedMenu() {
      this.addedMenu.open = !this.addedMenu.open;
    },

    onSortChange() {
      this.search();
    },

    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let params = this.getParams();

      if (this.totalPages >= this.currentPage) {
        learnApi
          .fetchList(params)
          .then((response) => {
            responseData = response.data.data;
            _.map(responseData.content, (o) => {
              o.progressViewStatus = false;
            });
            this.listData = this.listData.concat(responseData.content);
            this.listData1 = this.listData;
            this.currentPage++;
            this.totalPages = responseData.totalPages;
            this.totalElements = responseData.totalElements;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }

      // 캠페인 테이터 API 호출(get campaign data)
      let locationType =
        this.$route.query.status === "LEARNING"
          ? "LEARN_IN_PROGRESS_DEGREE"
          : "LEARN_COMPLETED_DEGREE";
      campaignApi
        .campaign({ locationType: locationType })
        .then((response) => {
          this.campaignData = response.data.data;
        })
        .catch((err) => {});
    },

    // 파라미터 설정(set parameter)
    getParams() {
      if (this.contents.length > 0) {
        this.$route.query.searched = "1";
      }
      /*
      as-is : 
        GET /learn/learner/online?page=1&size=10&name=&order=REGISTRATION_DATE&sortType=DESC&categories=5&categories=1
      to-be : 
        GET /learn/learner/online?page=1&size=10&name=&order=REGISTRATION_DATE&sortType=DESC&groupCategoryId=1
      */
      const groupCategoryId = this.$route.query.groupCategoryId;
      const categoryId = this.$route.query.category;
      console.log("groupCategoryId > ", groupCategoryId);
      console.log("categoryId > ", categoryId);

      let params = `?page=${this.currentPage}&size=10&name=${
        this.contents
      }&order=${this.sort_selected}&sortType=${this.sort_type}&${
        groupCategoryId ? `groupCategoryId=${groupCategoryId}` : ""
      }${
        categoryId === "ALL" || !categoryId ? "" : `&categories=${categoryId}`
      }`;

      return params;
    },

    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
    // Open drawer
    openDrawer() {
      this.isDrawerOpen = true;
      const modalAside = document.querySelector(".mdc-drawer--modal");
      const modalAsideIndex = [...modalAside.classList].indexOf(
        "mdc-drawer--open"
      );
      if (this.isDrawerOpen && modalAside && modalAsideIndex === -1) {
        modalAside.classList.add("mdc-drawer--open");
      }
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },
    searchOpen() {
      this.$nextTick(() => {
        this.$refs.search_form.focus();
      });
      $(".search_box").show();
      // $(".sm_star").addClass("backBg");
    },
    searchClose() {
      $(".user_fixed").show();
      $(".search_box").hide();
      $(".sm_star").removeClass("backBg");
      $(".sm_list.learning").css("padding-top", "90px");

      this.contents = "";
      this.initData();
    },
    search() {
      this.initData();
      // $(".search_box").hide();
      $(".sm_list.learning").css("padding-top", "15px");
      $(".user_fixed").hide();
      $(".sm_star").removeClass("backBg");
    },
    inputSearch(e) {
      if (e.keyCode == 13) {
        this.search();
      } else {
        $(".sm_star").addClass("backBg");
      }
    },
    dimBg() {
      $(".sm_star").addClass("backBg");
    },
    changeMode(mode) {
      this.listType = mode;
    },
    onToggle() {
      this.progressRateOrder = !this.progressRateOrder;
      localStorage.setItem(
        learnSortConstants.isProgressRateOrder,
        this.progressRateOrder
      );
      this.search();
    },
    getSortLabel(sortKey) {
      const sortLabels = {
        [this.learnSortConstants.registrationDate]: this.$t("S10044"),
        [this.learnSortConstants.likes]: this.$t("S20135"),
        [this.learnSortConstants.courseTitle]: this.$t("S10045"),
      };
      return sortLabels[sortKey] || this.$t("S10044");
    },
  },
};
</script>

<style scoped>
.sm_header {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 55px;
  z-index: 4;
  background-color: #fff;
  border: none;
  box-shadow: none;
}
.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 1.25rem;
  font-weight: 500;
  height: 55px;
  line-height: 55px;
  top: 0px;
  margin: 0;
}
.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}
.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}
.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}
.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}
.sm_header .search_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/search_btn.svg) center center no-repeat;
  background-size: 22px auto;
}
.sm_header .search_btn span {
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .back_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/back_btn.png) center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .more_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/more_btn.png) center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.sm_header .more_box {
  position: absolute;
  right: 15px;
  top: 45px;
  width: 80px;
  z-index: 10;
}

.search_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
  display: none;
}
.search_box .search_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/close_btn.svg) center center no-repeat;
  background-size: 22px auto;
  text-indent: -9999px;
}
.search_box .search_form {
  position: absolute;
  left: 60px;
  top: 12px;
  border: 0;
  background: #fff;
  font-size: 18px;
  color: #212121;
  height: 30px;
  width: calc(100% - 125px);
}
.sm_star.backBg:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}
input:focus {
  outline: none !important;
  border: none;
}

.sort-button {
  border: none;
  width: 50%;
  background-color: #fafafa;
}

.toggle-menu.more_box {
  top: 36px !important;
  width: 150px;
  right: 0;
}

.box-right {
  left: auto !important;
  right: 0px !important;
}

li.mdc-list-item {
  background-color: white;
}

.more_box li.mdc-list-item::after,
.more_box li.mdc-list-item::before {
  display: none;
}
.divider-line {
  border-bottom: 1px solid rgba(206, 218, 220, 0.7);
}

.primary-sorting {
  position: sticky;
  z-index: 4;
  top: 48px;
  background: #fafafa;
  padding-top: 4px;
}
.top-app-bar__learn {
  position: sticky;
  top: 0;
  z-index: 4;
  background: white;
  border-bottom: 1px solid rgba(206, 218, 220, 0.7);
}

.active-checked {
  color: var(--LogoBlue) !important;
}
.toggle-size {
  font-size: 32px;
  color: grey;
}
</style>